import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import MyTabs2 from "./MyTabs2";

export default function BarChart2({
  name,
  data,
  className,
  days,
  onTabChange,
  onBonusTabChange,
  bonusList = [],
}) {
  // Extract X-axis and Y-axis values
  const categories = data.map((item) => item.date); // ["Nov 21, 2025", ...]
  const values = data.map((item) => Number(item.claimed)); // [2, 665, 6665]
  const [isDark] = useState(localStorage.getItem("theme") === "dark");
  const [bonusTab, setBonusTab] = useState(() => {
    return localStorage.getItem("bonusTab") || "DAILYBONUS";

  });

  useEffect(() => {
    localStorage.setItem("bonusTab", bonusTab);
  }, [bonusTab]);

  const series = [
    {
      name: name,
      data: values,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    // ✅ Set bar color here
    colors: ["#6366F1"], // Indigo

    dataLabels: { enabled: false },

    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "20%",
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          colors: isDark ? "#d7dcde" : "#001321", // light vs dark
          fontSize: "10px",
        },
      },
    },
    // ✅ Prefix ₹ on Y-axis
    yaxis: {
      labels: {
        formatter: (val) => val.toLocaleString(),
        style: {
          colors: isDark ? "#d7dcde" : "#001321", // light vs dark
          fontSize: "10px",
        },
      },
    },
    // ✅ Prefix ₹ in tooltip popup
    tooltip: {
      x: {
        formatter: (_, { dataPointIndex }) => data[dataPointIndex].date,
      },
      y: {
        formatter: (val) => (val < 1 ? "Not Claimed" : `${val} Claimed`),
      },
    },
    grid: {
      borderColor: isDark ? "#56565c" : "#001321", // Tailwind slate-200
      //stroke size
      //  strokeDashArray: 4,
      strokeWidth: 1,
    },
  };

  return (
    <div
      className={`bg-white dark:bg-slate-900/90 p-4 rounded-2xl shadow-md w-full ${className || ""}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center justify-center space-x-2">
          <select
            name="sortBy"
            value={bonusTab || "nothing"}
            onChange={(e) => {
              setBonusTab(e.target.value);
              onBonusTabChange(e.target.value);

              
            }}
            placeholder="Enter Gateway Name"
            id=""
            className={` px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border  
              rounded-md 
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all ${"border-slate-200 dark:border-slate-700"}`}
          >
            {bonusList.map((bonus, index) => (
              <option key={index} value={bonus}>
                {bonus}
              </option>
            ))}
          </select>
          <h1 className="text-[13px] font-semibold  text-slate-700 dark:text-slate-200 ">
            {`Claimed in last ${days} days`}
          </h1>
        </div>
        <MyTabs2
          tabs={[
            { label: "7.Days", days: 7 },
            { label: "15.Days", days: 15 },
            { label: "30.Days", days: 30 },
          ]}
          onTabChange={(tab) => onTabChange(tab.days)}
        />
      </div>

      <ReactApexChart
        options={options}
        series={series}
        type={"bar"}
        height={220}
        // width={300}
      />
    </div>
  );
}
